export default function updateHeaderFavourites (favCount) {
  if (typeof window !== 'undefined') {
    const liContainer = window.document.getElementById('favourite-li')
    if (liContainer) {
      liContainer.style.display = favCount === 0 ? 'none' : 'inline-block'
    }

    const countElement = window.document.getElementById('favourites_count')
    if (countElement) {
      countElement.innerHTML = favCount + ''
    }
  }
}
